angular.module('jv.candidate.details.summary.controller',[])
    .controller('jvCandidateDetailsSummaryController', ['$scope','$rootScope','$routeParams','candidates','$location','$window', '$filter', 'jvCandidatesViewfieldsFactory','$timeout','jvFormFieldDropDownValuesFAC', 'ApplyFormPreviewService', 'currentUserService','$sce','jvHireUrlService','jvHireBroadcastSVC','$log','jvCandidatesService',
        function($scope,$rootScope,$routeParams,candidates ,$location, $window, $filter, jvCandidatesViewfieldsFactory,$timeout,jvFormFieldDropDownValuesFAC, ApplyFormPreviewService, currentUserService, $sce, jvHireUrlService,jvHireBroadcastSVC,$log, jvCandidatesService){
            $scope.LIScriptCounter = 0;
            $scope.flags.loading = true;
            $scope.showComment = false;
            $scope.isDefined = angular.isDefined;
            if(angular.isDefined($window.LIRSCEnabled)){
                $scope.linkedInRscEnabled = $window.LIRSCEnabled;
            }
            $scope._currentUser = currentUserService;
            $scope.dataConsent = {
                seekConsent: {
                    show: false
                },
                exportDataModa: {
                    show: false
                },
                template:{}
            };

            /*@for cases when the URL has readMode=0 all subsequent calls need to have readMode=0 param*/
            $scope.readMode= angular.isDefined($routeParams.readMode) && $routeParams.readMode==='0';

            $scope.hideModal = function(){
               $scope.dataConsent.seekConsent.show = false;
            };

            $scope.changeDataConsentTemplate = function(selectedTemplate){
               $scope.dataConsent.template.subject = selectedTemplate.subject;
               $scope.dataConsent.template.content = selectedTemplate.body;
               $scope.dataConsent.template.locale = selectedTemplate.locale;
            };

            $scope.exportData = function(){
               var name = i18n.CANDIDATE;
               if($scope.appDetails.application.candidate.firstName || $scope.appDetails.application.candidate.lastName){
                   name = $scope.appDetails.application.candidate.firstName +' '+ $scope.appDetails.application.candidate.lastName;
                   name = name.trim();
               }
               var data = {
                   id: $routeParams.applicationId,
                   type: 'CandidateDataExport',
                   name: name
               };
               window.localStorage.setItem('fileDownloadParams', JSON.stringify(data));
               var win = $window.open($scope.jvUrls.jhire+'/htm/common/bulkDownloadFile.html', '_blank');
               win.blur();
            };

            $scope.getSeekConsent = function(){
               $scope.flags.loading= true;
               candidates.getSeekConsentTemplate($routeParams.applicationId, function(response){
                   $scope.flags.loading= false;
                   $scope.dataConsent.template.list = $scope.select2Options.setTemplates(response.consentTemplates);
                   var defaultIndex = 0;
                   for(defaultIndex=0; defaultIndex<$scope.dataConsent.template.list.length; defaultIndex++){
                       if($scope.dataConsent.template.list[defaultIndex].isDefault){
                           break;
                       }
                   }
                   $scope.dataConsent.seekConsent.show = true;
                   $scope.dataConsent.template.sendUser = true;
                   $scope.dataConsent.template.selectedTemplate=$scope.dataConsent.template.list[defaultIndex];
                   $scope.changeDataConsentTemplate($scope.dataConsent.template.list[defaultIndex]);
               }, function(err){
                   $scope.flags.loading= false;
                   $log.error(err);
               });
            };

            $scope.sendSeekConsentMessage = function(){
               if((!$scope.dataConsent.template.content || $scope.dataConsent.template.content.trim().length === 0)
                       || (!$scope.dataConsent.template.subject || $scope.dataConsent.template.subject.trim().length === 0)){
                   return;
               }
               $scope.flags.loading= true;
               var template = angular.copy($scope.dataConsent.template);
               var postData = {};
               postData.sendAnonymously=true;
               if(template.sendUser){
                   postData.sendAnonymously=false;
               }
               postData.subject = template.subject;
               postData.content = template.content;
               candidates.sendSeekConsentMessage($routeParams.applicationId, postData, function(response){
                   $scope.flags.loading= false;
                   if(response.msgInfo === 200){
                       $scope.hideModal();
                       $scope.showMsg('MESSAGE_SENT');
                       $scope.appDetails.applicationConsent = response.applicationConsent;
                   }
               }, function(err){
                   $scope.flags.loading= false;
                   $log.error(err);
               });
            };

            if($location.path().indexOf('/edit') > 0){
                var path = angular.copy($location.path());
                $scope.$root.appCandDetailEdit = 2;
                $location.path(path.split('/edit').join(''));
            }

           if($location.path().indexOf('/edit') > 0){
                jvHireBroadcastSVC.subscribe('$locationChangeStart', function(e){
                   if($scope.candidateDetails.editMode || $scope.applicationDetails.editMode) {
                       var isConfirm= window.confirm(i18n.NAV_AWAY_WARNING_MESSAGE + '\n\n' + i18n.NAV_AWAY_CONFIRM);
                       if(!isConfirm){
                           e.preventDefault();
                           $rootScope.flags.loading = false;
                       }else{
                           $scope.candidateDetails.editMode= false;
                           $scope.applicationDetails.editMode= false;
                       }
                   }
               });
           }

            // flag to check if any form on the page is in edit mode
            $scope.$on('isFormEditInProgessEvt', function() {
                $rootScope.isFormEditInProgress = $scope.candidateDetails.editMode || $scope.applicationDetails.editMode || $scope.appSource.edited;
            });

            jvHireBroadcastSVC.subscribe('TAB_GetCandidateDetails', function(event, data){
                $scope.candidateDetails.onGetSuccess(data);
            });
            
            var getApplicationSummary = function(applicationEId, fastRead){
                jvCandidatesService.getApplicationSummary({
                    applicationEId: applicationEId,
                    readMode: fastRead.readMode
                }, function(data){
                    //populate candidate details with already resolved candidate details
                    if(angular.isDefined($window.__applicationDetails.candidateDetails)){
                        $scope.candidateDetails.onGetSuccess($window.__applicationDetails.candidateDetails);
                    }
                    if(angular.isDefined($window.__applicationDetails.workEducationData)){
                        $scope.renderProfileData($window.__applicationDetails.workEducationData);
                    }
                    if ($scope.perms.APPLICATION_APPLICATIONS_APP_DETAILS_GET) {
                        $scope.applicationDetails.onGetSuccess(data);
                    }
                    if ($scope.perms.APPLICATION_SOURCES_GET) {
                        $scope.appSource.onFetchSuccess(data);
                    }
                    if ($scope.perms.APPLICATION_COLLECTION_GET) {
                        $scope.collections.postFetch(data);
                    }
                    $rootScope.isLinkedInAcSourceName = data.jobBoard && data.jobBoard.sourceName === 'LinkedIn Apply Connect' ? true : false;
                });
            };
            
            $scope.$watch('appDetails', function(newVal, oldVal){
                if(!$.isEmptyObject(newVal) && newVal.application){
                    getApplicationSummary($routeParams.applicationId, $scope.pageReadMode());
                    //set dispositionEId if not yet done
                    if($scope.LIScriptCounter !== 0 && newVal === oldVal) {
                        return;
                    }
                    if($scope.perms.APPLICATION_SHOW_CONTACT){
                        $scope.fireSocialProfiles($scope.appDetails);
                    }
                    if(angular.isUndefined($scope.applicationDispositionEId) || $scope.applicationDispositionEId !== newVal.application.dispositionEId){
                        $scope.applicationDispositionEId = angular.copy(newVal.application.dispositionEId);
                    }
                }
            });

            //Render profile data inside the identity module
            $scope.renderProfileData = function(data){
                $scope.profile = {};
                if (data.education) {
                    var educationList = [];
                    angular.forEach(data.education, function(education) {
                        educationList.push(education['collegeName']);
                    });
                    $scope.educationHistoryData = data.education;
                    $scope.profile.education = educationList.join(', ');
                }
                if (data.workHistory) {
                    var workHistoryList = [];
                    angular.forEach(data.workHistory, function(workHistory) {
                        workHistoryList.push(workHistory['companyName']);
                    });
                    $scope.workHistoryData = data.workHistory;
                    $scope.profile.employment = workHistoryList.join(', ');
                }
                $scope.profile.userEdited = data.userEdited;
            };

           $scope.pageReadMode= function(fastRead){
                var mode={};
                if(fastRead || $scope.readMode || $rootScope.fastRead.summary){
                    mode.readMode = 0;
                    $scope.fastRead.summary = true;
                }else{
                    mode.readMode = 1;
                }
                return mode;
            };

            $scope.isEmailValid = function(email){
                if(!window.EMAIL_REGEX){
                    throw new Error('EMAIL_REGEX is not defined');
                }
                var emailPattern = new RegExp( window.EMAIL_REGEX );
                return emailPattern.test(email);
            };

            $scope.removeLoaderOnError= function(){
                $scope.flags.loading= false;
            };

            function normalizeString(str) {
                return str ? str.normalize('NFC') : str;
            }

            $scope.candidateDetails = {
                fields:{},
                cloneFields:{},
                fetchedCountries:{},
                editMode: false,
                onGetSuccess: function(data){
                    $scope.candidateDetails.fields = data;
                    $scope.candidateDetails.editMode=false;
                    $scope.candidateDetails.cloneFields={};
                    $scope.flags.loading = false;
                    if($scope.$root && angular.isDefined($scope.$root.appCandDetailEdit) && $scope.$root.appCandDetailEdit > 0){
                        $scope.$root.appCandDetailEdit--;
                        $scope.candidateDetails.edit();
                    }
                },
                get: function(fastRead){
                    $scope.flags.loading=true;
                    jvCandidatesViewfieldsFactory.getCandidateViewFields($routeParams.applicationId, $scope.pageReadMode(fastRead), this.onGetSuccess);
                },

                edit: function(){
                    $scope.flags.loading= true;
                    this.cloneFields= angular.copy($scope.candidateDetails.fields);
                    this.countries.get();
                    this.editMode=true;

                    candidates.candDetailsEdit($routeParams.applicationId, function(res){
                        candidates.getFilteredData(res).then(function(data){
                            $scope.candidateDetails.fields = data.viewFields;
                            angular.forEach($scope.candidateDetails.fields, function(field) {
                               if(field.name==='Country'){
                                    $scope.candidateDetails.countries.parse(field);
                                }
                                else if(field.fieldId === -66) {
                                     field.value = field.data;
                                 }

                                else if(field.fieldId === -63) {
                                    var modelValue = field.value && field.value.split('\n');
                                    field.value = modelValue && modelValue[0];
                                    var data = {};
                                    angular.forEach(field.data, function (item) {
                                        if(!item) {
                                            return;
                                        }
                                        data[item.key] = {values: item.value, model: {}};
                                        angular.forEach(item.value, function (value) {
                                            if(modelValue.indexOf(value.key.toString()) > -1) {
                                                data[item.key].model[value.key] = true;
                                            }
                                        });
                                    });
                                    field.data = data;
                                }
                            });
                            $scope.flags.loading= false;
                        });
                    },$scope.removeLoaderOnError);
                },

                cancel: function(){
                    this.fields= angular.copy(this.cloneFields);
                    this.editMode=false;
                    //this.cloneFields={};
                },

                countries:{
                    list:{},
                    get: function(){
                        /* @get countries list*/
                        candidates.getCountries(function(data){
                            $scope.candidateDetails.countries.list = data.resultList;
                        },$scope.removeLoaderOnError);
                    },
                    isUSA: false,
                    parse: function(field){
                        this.isUSA= field.value=== 'United States'?true :false;
                    }
                },

                postParam:{},
                validate: function(viewFields){
                    var data={};
                    var formValid=true;

                    angular.forEach(viewFields, function(field){
                        if(formValid){
                            /*@ mandatory field check*/
                            field.value = angular.isDefined(field.value) ? field.value : '';
                            if(field.required && !field.readOnly){
                                if(!field.value){
                                    formValid=false;
                                }
                            }
                            if(field.fieldId===-3 && field.value){
                                formValid= $scope.isEmailValid(field.value) ? true : false;
                            }
                            data[field.EId]=field.value;

                            if(field.fieldId === -66 && field.value) {
                                var locationContent  = '';
                                for (var i = 0; i < field.value.length; i++) {
                                 locationContent = locationContent + field.value[i]+'|';

                                 }
                                data[field.EId] = locationContent;
                            }

                            if(field.fieldId === -63) {
                                var radioModel = data[field.EId];
                                var temporaryCheckboxModel = '';
                                if(angular.isDefined(field.data[radioModel])) {
                                    var checkboxModel = field.data[radioModel].model;
                                    angular.forEach(checkboxModel, function (value, key) {
                                        if(value) {
                                            temporaryCheckboxModel = temporaryCheckboxModel + '|' + key;
                                        }
                                    });
                                    data[field.EId] = data[field.EId] + temporaryCheckboxModel;
                                }
                            }
                        }else{
                            data={};
                        }
                    });
                    return data;
                },

                save:function(){
                    this.postParam=$scope.candidateDetails.validate(this.fields);

                    if(!$.isEmptyObject(this.postParam)){
                        $scope.flags.loading = true;
                        var candidateEId=$scope.appDetails.application.candidateEId;

                        candidates.postCandDetailsEdit(this.postParam, $routeParams.applicationId, candidateEId, function(res){
                            if(res.msgInfo === 200){
                                $scope.showMsg('CAND_DETAILS_UPDATED');
                                //updating the application's candidate object on edit
                                $scope.appDetails.application.candidate = res.candidate;
                                $scope.candidateDetails.get(true);
                                $rootScope.$emit('update_identity_module');
                            }else{
                                $scope.removeLoaderOnError();
                            }
                        },$scope.removeLoaderOnError);
                    }
                }
            };

            $scope.jobBoardSourceSelectConfig = {
                ajax: {
                    type: 'GET',
                    data: function (term) {
                        return {
                            keywords: term
                        };
                    },
                    results: function(data){
                        return {
                            results: data.sourceType
                        };
                    }
                }
            };

            $scope.fieldIsNAN = function(field){
                var invalid = false;
                if(!field.readOnly && (field.fieldType=== 'Number' || field.fieldType=== 'Amount') && field.value && isNaN(field.value)){
                    invalid = true;
                }
                return invalid;
            };

            $scope.fieldIsInvalid= function(field){
                var invalid=false;
                //==> check for empty field if it is mandatory and readonly
                if(field.required && !field.readOnly){
                    if(field.fieldType==='CheckBox'){
                        //==> none of the option is selected for checkbox field
                        var checkBoxIsEmpty=true;
                        angular.forEach(field.values, function(checkboxOption){
                            if(checkboxOption.checked){
                                checkBoxIsEmpty=false;
                            }
                        });
                        invalid= checkBoxIsEmpty? true: false;
                    }else{
                        invalid= !field.value;
                    }
                }
                return $scope.applicationDetails.validationMode && invalid;
            };

            $scope.cleanFieldValue= function(fieldValue){
                if(fieldValue){
                    var selectedValues=fieldValue.split('\n');
                    var cleanedValues=[];
                    for(var i=0; i<selectedValues.length; i++){
                        if(selectedValues[i]){
                            cleanedValues.push(selectedValues[i]);
                        }
                    }
                    return cleanedValues.join('<br>');
                }
                return '';
            };

            $scope.applicationDetails={
                fields:{},
                viewFields:{},
                editMode:false,
                validationMode:false,
                postParams:{},
                onGetSuccess: function(data){
                    if(data && data.details && data.details.length){
                        $scope.applicationDetails.fields = data.details;
                        $scope.applicationDetails.editMode = false;
                        $scope.applicationDetails.validationMode=false;
                        if($scope.$root && angular.isDefined($scope.$root.appCandDetailEdit) && $scope.$root.appCandDetailEdit > 0){
                            $scope.$root.appCandDetailEdit--;
                            $scope.applicationDetails.edit();
                        }
                    }
                    $scope.flags.loading = false;
                },
                get:function(fastRead){
                    $scope.flags.loading=true;
                    candidates.getAppFieldDetails($routeParams.applicationId,$.param($scope.pageReadMode(fastRead), true), this.onGetSuccess, $scope.removeLoaderOnError);
                },

                edit:function(){
                    $scope.flags.loading = true;
                    candidates.edit($routeParams.applicationId, function(data){
                        if(data && data.viewFields){
                            $scope.applicationDetails.viewFields = data.viewFields;
                            $scope.applicationDetails.currencyMap = data.currencyMap;
                            $scope.applicationDetails.editMode = true;

                            /*@Formatting checkbox: adding selected value to CheckBox*/
                            angular.forEach($scope.applicationDetails.viewFields, function(field){
                                if(field.fieldType==='CheckBox' && field.value && field.values){
                                    var selectedValues= field.value.split('\n');
                                    angular.forEach(field.values, function(checkboxOption){
                                        if($.inArray(checkboxOption.key, selectedValues)>=0){
                                            checkboxOption.checked=true;
                                        }
                                    });
                                } else if(field.fieldType === 'Currency' && field.value){
                                    field.value = {
                                        currencyCode: field.unitOfMeasure,
                                        value: angular.copy(field.value)
                                    };
                                }
                                if(field.objectType && field.objectType === 'Divider'){
                                    field.fieldType = 'Divider';
                                }
                            });

                            angular.forEach($scope.applicationDetails.viewFields, function(field) {
                                if(field.fieldType === 'DropDown' && field.values && field.value) {
                                    var found = field.values.find(function(opt) {
                                        return normalizeString(opt.key) === normalizeString(field.value);
                                    });
                                    if (found) {
                                        field.value = found.key;
                                    } else {
                                        field.value = '';
                                    }
                                }
                            });
                        }
                        $scope.flags.loading = false;
                    },$scope.removeLoaderOnError);
                },

                validate: function(fields){
                    var data ={};
                    for(var eachfield in fields){
                        var field=fields[eachfield];
                        if(!$scope.fieldIsInvalid(field) && !$scope.fieldIsNAN(field)){
                            if(field.fieldType){
                                if(field.fieldType==='Date' && field.value){
                                    //var d = new Date(field.value);
                                    data[field.EId] = field.value;
                                }else if((field.fieldType==='Employee' || field.fieldType==='EmployeeNoDefault') && field.value){
                                    data[field.EId]= data[field.EId] || [];
                                    data[field.EId].push(field.value.EId);
                                }else if(field.fieldType==='CheckBox'){
                                    for(var index in field.values){
                                        var option = field.values[index];
                                        data[field.EId]=data[field.EId] || [];
                                        if(option.checked){
                                            data[field.EId].push(option.key);
                                        }else{
                                            data[field.EId].push('');
                                        }
                                    }
                                }else if(field.fieldType==='Currency'){
                                    data[field.EId] = field.value && field.value.currencyCode && field.value.value ? field.value : '';
                                }else{
                                    //Fix for bug 15094
                                    /*For cases where we dont have a field.value we still need to send empty string to the backend
                                    This check was not allowing that NV*/
                                    if(field.value){
                                        data[field.EId] = field.value;
                                    }else{
                                        data[field.EId] = '';
                                    }
                                }
                            }
                        }else{
                            data={};
                            break;
                        }
                    }
                    return data;
                },

                cancel:function(){
                    this.editMode=false;
                },

                save:function(){
                    this.validationMode=true;
                    this.postParams=this.validate(this.viewFields);
                    if(!$.isEmptyObject(this.postParams)){
                        this.showError=false;
                        $scope.flags.loading = true;

                        candidates.update($routeParams.applicationId,$scope.serializeObject(this.postParams),function(data){
                            if(data.msgInfo===200 || data.msgInfo===400){
                                $scope.showMsg('CHANGES_SAVED');
                                $scope.applicationDetails.get(true);
                                $rootScope.$emit('update_identity_module');
                            }else{
                                $scope.removeLoaderOnError();
                            }
                        }, $scope.removeLoaderOnError);
                    }else{
                        this.showError=true;
                    }
                },
                fieldValuesParams: jvFormFieldDropDownValuesFAC
            };

           $scope.appSource = {
                sources: [],
                sourceTypes  : [],
                sourceChannel:[],

                //==list of complete source types for FE reference, should be in sync with BE//
                sourceKinds :{
                    Referral: {category:'people', fieldId:''},
                    EmployeeEntered: { category:'people', fieldId:''},
                    EnteredForEmployee: { category:'people', fieldId:''},
                    Agency: {category:'people', fieldId:'-21'},
                    CareerSite:{},
                    JobBoard:{category:'jobBoard'},
                    Notification:{},
                    EnteredByRecruiter: { category:'people', fieldId:'-16'},
                    EnteredByHiringManager: { category:'people', fieldId:'-17'},
                    InternalApplication:{},
                    InternalTransfer:{},
                    Import:{},
                    Custom:{category:'subType'},
                    CustomWithName:{category:'text'},
                    Email: {category: 'text'},
                    FederatedSearch:{},
                    Share:{},
                    ResumeSearch:{}
                },
                onFetchSuccess: function(response){
                    $scope.appSource.applicationComment = response.applicationComment||'';
                    var index=-1;
                    $scope.appSource.edited = false;
                    angular.forEach(response, function(connections, key){
                        if(key === 'users'){
                            angular.forEach(connections, function(source){
                                index++;
                                $scope.appSource.sources[index] = {
                                    sourceType: response.sourceType ||'',
                                    firstName: source.firstName||'',
                                    lastName: source.lastName||'',
                                    fullName: source.fullName,
                                    category: 'people'
                                };
                            });
                        }else if(key === 'jobBoard'){
                            $scope.appSource.sources = [];
                            var sourceMap = response.jobBoard;
                            var source = {
                                sourceType: sourceMap.sourceType,
                                sourceName: sourceMap.sourceName,
                                secondarySource: sourceMap.secondarySource
                            };
                            $scope.appSource.sources.push(source);
                        }else if(key === 'other'){
                            angular.forEach(connections, function(source, sourceName){
                                index++;
                                $scope.appSource.sources[index] = {};
                                $scope.appSource.sources[index].sourceType = sourceName;

                                if($scope.appSource.peopleSourceKinds[sourceName]){
                                    $scope.appSource.sources[index].fullName = source;
                                    $scope.appSource.sources[index].category = 'people';
                                }else if(!$.isEmptyObject(source) && source !== sourceName){
                                    $scope.appSource.sources[index].sourceName = source;
                                }
                            });
                        }else if(key === 'sourceChannel'){
                                $scope.appSource.sourceChannel=[];
                                angular.forEach(response.sourceChannel, function(source){
                                    $scope.appSource.sourceChannel.push(source);
                            });
                            var temp={'key':$scope.$parent.appDetails.application.candidate.firstName + ' '+$scope.$parent.appDetails.application.candidate.lastName,'value':i18n['CANDIDATE']};
                            $scope.appSource.sourceChannel.push(temp);
                        }
                    });
                },
                peopleSourceKinds: { 'Hiring Manager': true, Agency : true},
                fetch: function(){
                    var readMode = $routeParams.readMode;
                    if($rootScope.fastRead.summary){
                        readMode = '0';
                    }
                    candidates.appSources($routeParams.applicationId, readMode, this.onFetchSuccess);
                },

                edit: function(){
                    $scope.appSource.edited = true;
                    $scope.appSource.showError= false;
                    candidates.appSourceTypes(function(response){
                        $scope.appSource.sourceTypes= response.sourceTypes;
                    });
                },

                selectSourceType: function(connectionEId){

                    if(connectionEId){
                        $scope.appSource.selectedSource={};
                        $scope.appSource.selectedSource.sourceTypeId=connectionEId;

                        angular.forEach($scope.appSource.sourceTypes, function(sourceType){

                            if(sourceType.EId === $scope.appSource.selectedSource.sourceTypeId){
                                if($scope.appSource.sourceKinds[sourceType.kind]){
                                    if($scope.appSource.sourceKinds[sourceType.kind].category) {
                                        $scope.appSource.selectedSource.category= $scope.appSource.sourceKinds[sourceType.kind].category;
                                        $scope.appSource.selectedSource.kind= $scope.appSource.sourceKinds[sourceType.kind];

                                        if($scope.appSource.selectedSource.category=== 'subType'){
                                            if(sourceType.sourceTypes)
                                                {$scope.appSource.selectedSource.subTypes= sourceType.sourceTypes;}
                                            else
                                                {$scope.appSource.selectedSource.category= 'subTypeWithoutTypes';}
                                        }
                                        else if($scope.appSource.selectedSource.category==='text'){
                                            $scope.appSource.selectedSource.promptText = true;
                                            if(i18n['ENTER_'+ sourceType.kind.toUpperCase()] || sourceType.kind === 'CustomWithName')
                                                {$scope.appSource.selectedSource.placeholder = sourceType.promptText || i18n['ENTER_OTHER'];}
                                            else
                                                {$scope.appSource.selectedSource.placeholder= i18n['ENTER_OTHER'];}
                                        }
                                    }else{
                                        $scope.appSource.selectedSource.promptText = false;
                                    }
                                }
                            }
                        });
                    }else{
                        delete $scope.appSource.selectedSource;
                    }
                },

                selectSubType: function(){
                    if($scope.appSource.selectedSource.subTypeId && $scope.appSource.selectedSource.category==='subType'){
                        angular.forEach($scope.appSource.selectedSource.subTypes, function(subType){
                            if($scope.appSource.selectedSource.subTypeId=== subType.EId){
                                $scope.appSource.selectedSource.subTypeName= subType.name;
                                if(subType.promptText){
                                    $scope.appSource.selectedSource.promptText = true;
                                    $scope.appSource.selectedSource.placeholder = subType.promptText;
                                }else{
                                    $scope.appSource.selectedSource.promptText = false;
                                }
                            }
                        });
                    }else{
                        $scope.appSource.selectedSource.promptText = false;
                        delete $scope.appSource.selectedSource.subTypeId;
                    }
                },

                personField: function(){
                    var data={};
                    data.fieldId=$scope.appSource.selectedSource.kind['fieldId'];
                    return data;
                },

                prepareData: function(){
                    // application source will accept ConnectionId as SourceType
                    var data = {};
                    data.sourceName = '';
                    data.sourceType = $scope.appSource.selectedSource.sourceTypeId;

                    if($scope.appSource.selectedSource.category){

                            if( $scope.appSource.selectedSource.category ==='people'){
                                data.id = $scope.appSource.selectedSource.employee.EId;
                                data.firstName = $scope.appSource.selectedSource.employee.firstName;
                                data.lastname = $scope.appSource.selectedSource.employee.lastName;
                                data.sourceName = $scope.appSource.selectedSource.employee.fullName;
                            }else if($scope.appSource.selectedSource.category ==='subType' || $scope.appSource.selectedSource.category ==='subTypeWithoutTypes'){
                                if($scope.appSource.selectedSource.subTypes){
                                    data.sourceName = $scope.appSource.selectedSource.subTypeName;
                                    if($scope.appSource.selectedSource.promptText)
                                        {data.sourceName += ' : ' + $scope.appSource.selectedSource.sourceText;}
                                }
                            }else if($scope.appSource.selectedSource.category ==='jobBoard') {
                                if($scope.appSource.selectedSource.jobBoardSourceName){
                                    data.sourceName = $scope.appSource.selectedSource.jobBoardSourceName;
                                    if($scope.appSource.selectedSource.jobBoardSourceName.toUpperCase()=== 'JOBTARGET'){
                                        data.secondarySource = $scope.appSource.selectedSource.secondarySource;
                                    }
                                }

                            }else{
                                data.sourceName = $scope.appSource.selectedSource.sourceText;
                            }
                    }
                    return data;
                },

                save: function(){
                    if($scope.appSource.isSourceValid()){
                        var postData= $scope.appSource.prepareData();
                        if($rootScope.fastRead.summary){
                            postData = postData || {};
                            postData.readMode = 0;
                        }

                        $scope.flags.loading = true;

                        //update source type and source name
                        candidates.updateAppSource($routeParams.applicationId, postData, function(response){
                            if(angular.isDefined(response.msgInfo) && response.msgInfo === 200){
                                $rootScope.fastRead.summary = true;
                                //Set new source to currentSource to display on page. skiping server call to get info again
                                $scope.appSource.sources=[];
                                var currentSource= {};
                                if( $scope.appSource.selectedSource.category &&  $scope.appSource.selectedSource.category==='people'){
                                    currentSource.category= $scope.appSource.selectedSource.category;
                                    currentSource.fullName= postData.sourceName;
                                }else{
                                    currentSource.sourceName= postData.sourceName;
                                    currentSource.secondarySource= postData.secondarySource;
                                }
                                //Get the source name from fetched source list
                                angular.forEach($scope.appSource.sourceTypes, function(_source){
                                    if(_source.EId=== $scope.appSource.selectedSource.sourceTypeId){
                                        currentSource.sourceType= _source.name;
                                    }
                                });
                                $scope.appSource.sources.push(currentSource);

                                //Clearing flags and current source selection
                                $scope.appSource.edited = false;
                                $scope.flags.loading = false;
                                delete $scope.appSource.selectedSource;
                                delete $scope.appSource.connectionEId;
                                $rootScope.$emit('update_identity_module');
                            }
                        });
                    }
                },

                cancel: function(){
                    $scope.appSource.edited = false;
                    delete $scope.appSource.selectedSource;
                    delete $scope.appSource.connectionEId;
                },

                //Validate if source is selected properly else display error message
                isSourceValid : function(){
                    if(!$scope.appSource.selectedSource){
                        $scope.appSource.showError= true;
                        $scope.appSource.invalidMsg= i18n['SELECT_CONNECTION'];
                        return false;
                    }else if($scope.appSource.selectedSource.category==='people' && !$scope.appSource.selectedSource.employee){
                        $scope.appSource.showError= true;
                        $scope.appSource.invalidMsg= i18n['SELECT_A_EMPLOYEE'];
                        return false;
                    }else if($scope.appSource.selectedSource.category==='subType' && $scope.appSource.selectedSource.subTypes && !$scope.appSource.selectedSource.subTypeId){
                        $scope.appSource.showError= true;
                        $scope.appSource.invalidMsg= i18n['SELECT_CUSTOM_TYPE'];
                        return false;
                    }else if($scope.appSource.selectedSource.promptText && angular.isUndefined($scope.appSource.selectedSource.sourceText)){
                        $scope.appSource.showError= true;
                        $scope.appSource.invalidMsg= i18n['ENTER_SOURCE_NAME'];
                        return false;
                    }else if($scope.appSource.selectedSource.category ==='jobBoard' && angular.isUndefined($scope.appSource.selectedSource.jobBoardSourceName)) {
                        $scope.appSource.showError= true;
                        $scope.appSource.invalidMsg= i18n['SELECT_JOBBOARD_SOURCE'];
                        return false;
                    }
                    $scope.appSource.showError= false;
                    $scope.appSource.invalidMsg='';
                    return true;
                },
                /*source icon class name*/
                icon:function(sourceType,sourceChannel){
                    var availbleSourceType=['agency','campaign','careersite','email','employee','hiringmanager','import','internal','internaltransfer','jobboard','jobnotification','recruiter','facebook','linkedin','twitter','candidate'];
                    sourceType=sourceType.replace(/\s+/g, '');
                    sourceType=sourceType.toLowerCase();
                    if($.inArray(sourceType,availbleSourceType) >-1){
                        if(sourceType==='internaltransfer')
                            {sourceType='internal';}

                        return 'blue-icon-src-'+sourceType;
                    }else if(sourceChannel){
                        return 'blue-icon-src-othernetwork';
                    }else{
                        return 'blue-icon-src-custom';
                    }

                }
            };

            $scope.getApplicationSearchUrl = function(collectionId, collectionName) {
                return jvHireUrlService.getCandidateListPageUrl({
                    collectionIds: encodeURIComponent(collectionId),
                    collectionName:encodeURIComponent(collectionName),
                    redirect: 'redirect'
                });
            };

            $scope.collections = {
                appCollections : {},
                orderedAppCollections : [],
                otherCollections : {},
                allCollections : {},
                addExisting_eid : '',
                addNew_name : '',

                addExisting : function(eid) {
                    if (!eid) {
                        return;
                    }
                    var readMode = 1;
                    if($rootScope.fastRead.summary){
                        readMode = 0;
                    }
                    candidates.addExistingCollection($routeParams.applicationId,{eid : eid}, readMode,
                        function(response){
                            $scope.collections.appCollections[response.collections.EId] = response.collections;
                            $scope.collections.orderedAppCollections = $scope.collections.sortBy($scope.collections.appCollections,'name');
                            $scope.collections.addExisting_eid = '';
                            delete $scope.collections.otherCollections[eid];
                            $rootScope.fastRead.summary = true;
                            $scope.showMsg('COLLECTION_ADDED');
                        }
                    );
                },

                addNew : function(name) {
                    if (!name || !name.trim()){
                        return;
                    }
                    var readMode = 1;
                    if($rootScope.fastRead.summary){
                        readMode = 0;
                    }
                    candidates.addNewCollection($routeParams.applicationId,{name : name}, readMode,
                        function(response) {
                            $scope.collections.appCollections[response.collections.EId] = response.collections;
                            $scope.collections.orderedAppCollections = $scope.collections.sortBy($scope.collections.appCollections,'name');
                            $scope.collections.addNew_name = '';
                            delete $scope.collections.otherCollections[response.collections.EId];
                            $rootScope.fastRead.summary = true;
                            $scope.showMsg('COLLECTION_ADDED');
                        }
                    );
                },

                remove : function(eid) {
                    candidates.deleteCollection($routeParams.applicationId,{eid : eid},
                        function() {
                            $scope.collections.otherCollections[eid] = $scope.collections.appCollections[eid];
                            delete $scope.collections.appCollections[eid];
                            $scope.collections.orderedAppCollections = $scope.collections.sortBy($scope.collections.appCollections,'name');
                            $scope.showMsg('COLLECTION_DELETED');
                        }
                    );
                },

                fetch : function() {
                    var readmode = $routeParams.readMode;
                    if($rootScope.fastRead.summary){
                        readmode = '0';
                    }
                    candidates.collections($routeParams.applicationId, readmode,function(response){
                        $scope.collections.postFetch(response);
                    });
                },

                postFetch : function(response) {
                    angular.forEach(response.applicationCollections, function(collection) {
                        $scope.collections.appCollections[collection.collectionEId] = collection.collection;
                    });
                    $scope.collections.orderedAppCollections = $scope.collections.sortBy($scope.collections.appCollections, 'name');
                },

                sortBy : function(object, property) {
                    var arr = [];
                    for(var key in object){
                        if (object.hasOwnProperty(key)) {
                            arr.push(object[key]);
                        }
                    }

                    return arr.sort(function(a, b){
                        if (angular.isDefined(a[property]) && angular.isString(a[property])) {
                            a = a[property].toLowerCase();
                        } else {
                            a = a[property];
                        }
                        if (angular.isDefined(b[property]) && angular.isString(b[property])) {
                            b = b[property].toLowerCase();
                        } else {
                            b = b[property];
                        }
                        return a > b ? 1 : (a === b ? 0 : -1);
                    });
                }
            };

            $scope.postDisposition = function(dispositionEId){
                //Fix for when dispositin is getting changed on page load.NV HIRE-11337
                if(dispositionEId){
                    $scope.flags.loading = true;
                    var data = {
                        dispositionId: dispositionEId
                    };
                    if($rootScope.fastRead.summary){
                        data.readMode = 0;
                    }
                    candidates.postDisposition($scope.appDetails.application.EId, data, function(response){
                        if(response.msgInfo === 200){
                            $rootScope.fastRead.summary = true;
                            $scope.appDetails.application.dispositionEId = angular.copy(dispositionEId);
                            $scope.showMsg('DISPOSITION_CHANGED');
                        }
                        // Updates the appdetails data
                        $rootScope.$emit('update_identity_module');
                        $scope.flags.loading = false;
                    }, function(fail){
                        $scope.flags.loading = false;
                        $log.error(fail);
                    });
                }
            };

            $scope.fireLinkedIn = function(applicationObject){
                if($window.LICSAKey && $scope.perms.APPLICATION_APPLICATIONS_LINKEDIN_PROFILE_GET){
                    setTimeout(function(){
                        document.initLinkedIn($scope.appDetails.application.EId, null, $('#LinkedInIframe'), applicationObject, $window.LICSAKey);
                    }, 1000);
                }
             };
             
            $scope.fireSocialProfiles = function(applicationObject){
                if(applicationObject.application){
                    candidates.getContactId(applicationObject.application.candidateEId, function(data){
                        if(!$.isEmptyObject(data) && data.resultList){
                            candidates.fetchSocialProfiles(data.resultList[0].EId);
                            //process to discover the linkedIn id.
                            var base =  data.resultList[0];
                            applicationObject.application.candidate.linkedInId = base.linkedInId;
                            applicationObject.application.candidate.linkedInUrl = base.linkedInUrl;
                            applicationObject.application.candidate.noteId = base.linkedInInfoId;
                            applicationObject.application.candidate.contactEID = base.EId;
                            $scope.contactEId = base.EId;

                            var url = $window.jvUrls.jhire + '/modules/candidates/LIRSCFrame.html?applicationId=' + $scope.appDetails.application.EId + '&contactEid=' + base.EId;
                            $scope.liRscFrameurl = $sce.trustAsResourceUrl(url);
                            $scope.linkedInSyncStatus();
                            //initialize the linkedin object
                            var linkedInObject = {};
                            linkedInObject.firstName = applicationObject.application.candidate.firstName;
                            linkedInObject.lastName = applicationObject.application.candidate.lastName;
                            linkedInObject.customerId = applicationObject.application.candidate.contactEID;
                            linkedInObject.id = applicationObject.application.candidate.linkedInId;
                            linkedInObject.emailAddress = applicationObject.application.candidate.email;
                            linkedInObject.companyName = applicationObject.application.candidate.company;
                            linkedInObject.title = applicationObject.application.candidate.title;
                            linkedInObject.location = applicationObject.application.candidate.postalCode;
                            linkedInObject.noteId = applicationObject.application.candidate.noteId;

                            //pass the object into the
                            $scope.fireLinkedIn(linkedInObject);
                        }
                    }, function(err){
                        $log.error(err);
                    });
                    $scope.LIScriptCounter++;
                }
            };

            $scope.previewApplyForm = function (formId, formName) {
                $scope.applyFormName = formName;
                $scope.applyFormFields = null;
                $scope.modals = {
                    applyFormPreview: true
                };
                ApplyFormPreviewService.getForm(formId).then(function(fields) {
                    $scope.applyFormFields = fields;
                });
            };

            $scope.getSelectedApplyFormName = function(selectedForm, forms) {
                var form = forms.filter(function(f) {
                    return (f.key === selectedForm);
                });
                if (form[0]) {
                    return form[0].value;
                }
            };

            $scope.unlinkLinkedInProfile = function(memberToken,unlink) {
                var contactEid = $scope.contactEId;
                var applicationId=$scope.appDetails.application.EId;
                jvCandidatesService.unlinkLinkedInProfile({
                    contactEid:contactEid,
                    memberToken:memberToken,
                    unlink:unlink,
                    applicationId:applicationId
                });
             };

             $scope.showLinkedInSyncErrorIcon = false;
             $scope.linkedInSyncStatus = function() {
                 var contactId=$scope.contactEId;
                 var applicationId = $scope.appDetails.application.EId;
                 jvCandidatesService.getLinkedInCandidateSyncStatus({
                     contactEid: contactId,
                     applicationId:applicationId
                   },function(result){
                     if(result){
                           angular.forEach(result, function(syncDetails) {
                               if(syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT'){
                                   $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                   $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                               }
                           });
                       }
                 });
             };

             $scope.refreshLinkedInSync = function() {
                 var contactId=$scope.contactEId;
                 var applicationId = $scope.appDetails.application.EId;
                 jvCandidatesService.syncCandidateToLinkedIn({
                      contactEid: contactId,
                      applicationId:applicationId
                     },function(result){
                      if(result) {
                           angular.forEach(result, function(syncDetails) {
                               if( syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT' ){
                                   $scope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                   $scope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                               }
                           });
                       }
                  });
            };

}]);